import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import PersonProfileTable from './PersonProfileTable';

export default class TrainerProfileEntriesPage extends Component {
  static propTypes = {
    profile: PropTypes.object
  };

  render() {
    const {
      profile = {},
      profile: {
        person_details: {
          name
        } = {}
      } = {}
    } = this.props;

    return (
      <div className="hr-trainer-profile-results">
        <MetaDataWrapper title={`${name} - Trainer Future Entries`}/>
        <PersonProfileTable profile={profile} rideLabel="Horse" earlyEntries/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/TrainerProfileEntriesPage.js